import {IAction} from "src/context/IAction";
import {FETCH_SECTIONS, FETCH_SECTIONS_FAILURE, FETCH_SECTIONS_SUCCESS} from "src/context/actions/ActionTypes";
import {ISectionState} from "src/context/models/Section";
import {IErrorModel} from "src/context/states/IErrorModel";

const SectionsReducer = (state: ISectionState, {payload, type}: IAction): ISectionState => {
    switch (type) {
        case FETCH_SECTIONS:
            return {
                ...state,
                data: null,
                error: null,
                loading: true
            };
        case FETCH_SECTIONS_SUCCESS:
            return {
                ...state,
                data: payload,
                error: null,
                loading: false
            };
        case FETCH_SECTIONS_FAILURE:
            return {
                ...state,
                data: null,
                error: payload as IErrorModel,
                loading: false
            };
        default:
            return state;
    }
};

export default SectionsReducer;
